import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';

import { MaterialEspecificacao } from "../material-especificacao.model";
import { UtilService } from "../../../../../shared/services/util.service";
import { MaterialService } from "../../../material/shared/material.service";
import { MaterialEspecificacaoService } from "../material-especificacao.service";
import { materialEspecificacaoStorageName, materialStorageName } from "../../../material/shared/data.service";
import { AutoCompleteService } from "../../../../../shared/components/autocomplete/autocomplete.service";

declare var swal: any;

@Component({
  selector: 'material-especificacao-formulario',
  template: require('./material-especificacao-form.component.html')
})

export class MaterialEspecificacaoFormComponent implements OnInit {
  @Input() formObject: any = new MaterialEspecificacao();
  @Output() submitEvent: EventEmitter<any> = new EventEmitter();
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();

  btnSalveDisabled: boolean = false;
  submitAttempt: boolean = false;

  formMaterialEspecificacao: FormGroup;
  material: FormControl;
  especificacao: FormControl;
  descricao: FormControl;
  ativo: FormControl;

  materialRequired: boolean = true;
  materialFieldToFind: string = 'descricao';
  materialFieldToSort: string = 'descricao';
  materialFieldToShow: string = 'descricao';
  materialLabel: string = 'Material';
  materialSelectId: string = 'materialEspecificacao_material';

  private materialEspecificacaoModule: string = materialEspecificacaoStorageName;
  private materialModule: string = materialStorageName;
  private hasSession:boolean = false;

  constructor(
    private _materialEspecificacaoService: MaterialEspecificacaoService,
    private _materialService: MaterialService,
    private _autocompleteService: AutoCompleteService,
    private _utilService: UtilService,

    private builder: FormBuilder
  ){
    this.material = new FormControl('', Validators.required);
    this.especificacao = new FormControl('', Validators.required);
    this.descricao = new FormControl('', Validators.required);
    this.ativo = new FormControl();
    this.formMaterialEspecificacao = builder.group({
      ativo: this.ativo,
      material: this.material,
      especificacao: this.especificacao,
      descricao: this.descricao
    });
  }

  ngOnInit() {
    this.testSession();
    document.getElementById("materialEspecificacao_descricao").focus();

    if (this.formObject.id) {
      //edicao
      this.getObject();
    }
  }

  onSubmit(evt: any) {
    this.submitAttempt = true;
    if(evt.valid) {
      this.btnSalveDisabled = true;
      var object:any = this._utilService.cloneObject(this.formObject);

      if (object.material) {
        object.materialId = object.material.id;
      }

      delete object['material'];

      if (object.id) {
        this.onEditMaterialEspecificacao(object);
      } else {
        this.onSaveMaterialEspecificacao(object);
      }
    }
  }

  onclickCancel() {
    this.cancelEvent.next("");
  }

  //material
  onGetMaterialObject(object: any) {
    if(object.novo) {
      this._materialEspecificacaoService.setSessionStorage(this.formObject);

      var objectModel: any = {descricao: object.text, novo: true, form: this.materialEspecificacaoModule};
      this._autocompleteService.setSessionStorage(objectModel, this.materialModule);
      this._materialService.goToAdd();
    } else {
      this.formObject.material = object;
      this.setSelectOnFormControl('materialId', object);
    }
  }

  private onSaveMaterialEspecificacao(objeto: any) {
    this._materialEspecificacaoService.onPost(objeto, this.onDone);
  }

  private onEditMaterialEspecificacao(objeto: any) {
    this._materialEspecificacaoService.onPut(objeto, this.onDone);
  }

  private onDone = (function(Response: any) {
    this.submitEvent.next(Response);
    this.btnSalveDisabled = false;
  }.bind(this));

  private testSession() {
    var session: any = this._materialEspecificacaoService.getSessionStorage();
    if (session) {
      this.formObject = session;
      this.hasSession = true;
    }
  }

  private setSelectOnFormControl(item: string, object: any) {
    var tt: any = this.formMaterialEspecificacao.controls[item];
    tt.patchValue(object.id);
  }

  //se edicao
  private getObject() {
    var onDone = (function(Response: any) {
      if (!Response.error) {
        this.formObject = Response;
      } else {
        this._utilService.swalMessageWarningCustom('Nenhuma especificação encontrada com este id.');
        this.onclickCancel();
      }
    }.bind(this));

    this._materialEspecificacaoService.onGetById(this.formObject.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-especificacao/shared/material-especificacao-form/material-especificacao-form.component.ts
 **/